import { RouteObject } from 'react-router-dom';
import { Geography } from '../Geography';
import { CitiesRoutes } from '../Cities/routes';
import { DepartmentsRoutes } from '../Departments/routes';
import { OfficesRoutes } from '../Offices/routes';

export const GeographyRoutes: RouteObject[] = [
  {
    path: '',
    element: <Geography />,
  },
  ...CitiesRoutes,
  ...DepartmentsRoutes,
  ...OfficesRoutes,
];
